module.exports = __webpack_public_path__ + "img/printWhite.334a6275.svg";